import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Loader from "../components/Loader";
import "../App.css";
import "../css/skin-modes.css";
import "../css/custom.css";

const FAQS = [
  {
    id: "collapse_2",
    question: "Do you remove my items on the Cart and Orders pages?",
    answer: (
      <>
        Yes, we do it automatically. All items older than 3 days be deleted from your Shopping Cart.<br />
        All orders older than 3 months be deleted too.<br />
        Also the tickets and payments be deleted automatically in some time.<br />
        It's required for your security and our database performance.
      </>
    ),
  },
];

function Faq() {
  const [loading, setLoading] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="page" style={{ visibility: "visible", opacity: 1 }}>
      <div className="page-main is-expanded">
        <Header onToggleSidebar={() => setMobileMenuOpen(o => !o)} />
        <Sidebar mobileOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} active="faq" />
        <div className="app-content main-content mt-0">
          <div className="side-app">
            <div className="main-container container-fluid">
              <div className="page-header">
                <div>
                  <h1 className="page-title">Faq's</h1>
                </div>
                <div className="ms-auto pageheader-btn">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/wallet">Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Faq's</li>
                  </ol>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header border-bottom">
                      <h3 className="card-title">Faq's</h3>
                    </div>
                    <div className="card-body">
                      <div aria-multiselectable="true" className="accordion" id="accordion" role="tablist">
                        {FAQS.map(faq => {
                          const isOpen = openId === faq.id;
                          return (
                            <div className="acc-card mb-4" key={faq.id}>
                              <div className="acc-header" id={`heading_${faq.id}`} role="tab">
                                <h5 className="mb-0">
                                  <a
                                    aria-controls={faq.id}
                                    aria-expanded={isOpen}
                                    href={`#${faq.id}`}
                                    className={isOpen ? "" : "collapsed"}
                                    onClick={e => { e.preventDefault(); setOpenId(isOpen ? null : faq.id); }}
                                  >
                                    &mdash; {faq.question} <span className="float-end acc-angle"><i className="fe fe-chevron-right"></i></span>
                                  </a>
                                </h5>
                              </div>
                              <div
                                aria-labelledby={`heading_${faq.id}`}
                                className={`collapse${isOpen ? " show" : ""}`}
                                id={faq.id}
                                role="tabpanel"
                              >
                                <div className="acc-body">
                                  {faq.answer}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="footer">
          <div className="container">
            <div className="row align-items-center flex-row-reverse">
              <div className="col-md-12 col-sm-12 text-center">
                Copyright Patrick Market © 2025 All rights reserved
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default Faq;
